import { GETBYID_SUCCESS, GETBYID_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const holidayGetByIdReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETBYID_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETBYID_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default holidayGetByIdReducer;
